import React from 'react';
import {Box} from '@mui/material';
import {Tooltip} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import DropdownButton, {
  Option,
} from '@/components/dropdown-button/DropdownButton';
import ButtonEndBadge from './ButtonEndBadge';
import FilterMenuItem from './FilterMenuItem';
import FilterMenuTitle from './FilterMenuTitle';

interface FilterButtonProps {
  label: string;
  options: Option[];
  onChange: (option: Option) => void;
  selectedOptionIds: string[];
  isShowTitle?: boolean;
  disabled?: boolean;
}

export default function FilterButton({
  label,
  options,
  onChange,
  selectedOptionIds,
  isShowTitle = options.length > 8,
  disabled = false,
}: FilterButtonProps) {
  return (
    <Tooltip
      title={
        disabled
          ? translate("Turn off 'Show selected files only' to enable")
          : ''
      }
      arrow
      type="light"
      placement="top"
    >
      <Box>
        <DropdownButton
          label={label}
          options={options}
          onChange={onChange}
          menuProps={{sx: {maxHeight: '700px'}}}
          selectedOptionIds={selectedOptionIds}
          transparentSelectedBackground
          disabled={disabled}
          endIcon={
            selectedOptionIds?.length && !disabled ? (
              <ButtonEndBadge text={selectedOptionIds.length.toString()} />
            ) : null
          }
          renderMenuItem={(option, isSelected) => (
            <FilterMenuItem option={option} isSelected={isSelected} />
          )}
          renderMenuTitle={() => {
            if (isShowTitle) {
              return (
                <FilterMenuTitle
                  label={label}
                  onChangeSearch={() => {}}
                  onChangeOption={onChange}
                  selectedOptions={
                    selectedOptionIds
                      .map((optionId) => options.find((o) => o.id === optionId))
                      .filter((o) => o !== undefined) as Option[]
                  }
                />
              );
            }
            return null;
          }}
          closeAfterSelect={false}
        />
      </Box>
    </Tooltip>
  );
}
